
import BasePropertyView from 'BasePropertyView.js';
import nameTemplate from 'properties/main/assetName.ejs';

class MainAssetNameView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = nameTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'focusout input[type=text]' : 'updateAttributes',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus'
        };

        let name = this.model.get('name');
        let lastIndex = name.lastIndexOf(".");
        if (lastIndex > 0){
           this.extension = name.substr(lastIndex);
           this.model.set('tmpName', name.substr(0, lastIndex), {silent: true});
        }else{
            this.extension = '';
            this.model.set('tmpName', name, {silent: true});
        }   

        

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;
        this.model.set(propName, propVal + this.extension);
        this.model.set('tmpName', propVal);

        let asset = $('.carousel-inner .item #' + this.model.get('id'));

        if (asset.length) { 
            asset.find('.thumb p').text(propVal).prop('title', propVal);  
            asset.find('#asset-edit-' + this.model.get('id')).val(propVal);     
        }
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }
        this.delegateEvents();
        return this;
    }
}

export default MainAssetNameView;
